import React from "react"
import { Grid } from "semantic-ui-react"
import Button from "../Button"
import { faUser } from "@fortawesome/pro-regular-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { capitalizeEachWord } from "../../../shared_component/utils/stringHelpers"
import { truncatedNameWithTitle } from "../../helpers/shopHelpers"
import { useTranslation } from "react-i18next"
import { CARD_MARGIN } from "./ShopMapView"
import { capitalize } from "../../helpers/stringHelpers"
import { getPricingInfo } from "../../helpers/shopHelpers"
import { getNewTiresServiceFromServices } from "../../helpers/orderServiceHelpers"

export default function ShopMapCard({
  shop,
  selectedShop,
  onPreSelect,
  onSelect,
  shouldDisplayPrice,
  orderServices,
  vehicleTypeId
}) {
  const { t } = useTranslation(["shopMapCard", "common"])
  const isSelectedShop = shop === selectedShop
  const pricingInfo = getPricingInfo(
    !!getNewTiresServiceFromServices(orderServices),
    shop.supports_tire_selection,
    shop.shopPriceText,
    shop.shopPriceEstimate,
    shop,
    t,
    vehicleTypeId
  )
  const priceText = shouldDisplayPrice ? pricingInfo : ""
  const completedOrderCount = shop.completed_shop_orders_count
  const truncationLength = isSelectedShop ? 25 : 50

  return (
    <Grid
      onClick={() => onPreSelect(shop)}
      style={{ margin: `${CARD_MARGIN}px` }}
      className={`shopMapCard ${isSelectedShop ? "highlighted" : ""}`}
    >
      <Grid.Column width={isSelectedShop ? 11 : 16} style={{ padding: 0 }}>
        <strong>
          {truncatedNameWithTitle(
            capitalizeEachWord(shop.company && shop.company.name ? shop.company.name : shop.name),
            truncationLength
          )}
        </strong>
        <div>{capitalizeEachWord(shop.address_line1)}</div>
        <div>
          {`${t("milesAwayLbl", {
            value: shop.distance_config.display_quantity,
            unit: capitalize(shop.distance_config.units)
          })}`}
        </div>
        <div className="caradvise-electric-blue">{priceText}</div>
      </Grid.Column>
      {isSelectedShop && (
        <Grid.Column width={5} style={{ padding: 0 }}>
          <Button
            key="btn-select-shop"
            text={t("common:selectText")}
            colorStyle="orange"
            onClick={() => onSelect(selectedShop, pricingInfo)}
            style={{ height: "10px" }}
          />
        </Grid.Column>
      )}
      <div className="shopTransactionsCountSection">
        <FontAwesomeIcon className="userIcon" icon={faUser} size={"small"} />
        {completedOrderCount > 0 &&
          ` ${completedOrderCount} ${t("caradviseLbl", { count: completedOrderCount })} ${t(
            "servicedLbl"
          )}`}
        {completedOrderCount === 0 && ` ${t("firstOneToBookDesc")}`}
      </div>
    </Grid>
  )
}
